import { List, SpinLoading, Form } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { _ListLessonPlans } from "../../models/lessonPlans";
import { groupByMultiple } from "../../utils";
import { Card, Button } from "react-bootstrap";
import { jsonToQuery, lowerCase, momentDate, upperCase } from "../../utils";
import $ from "jquery";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";

const AttendanceTypeSelectView = (props) => {
  const [loader, setLoader] = useState(false);
  const [hostelId, setHostelId] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [service , setService ] = useState([]);
  const [serviceMatch , setServiceMatch ] = useState([]);

  
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const paramsField = (fieldName) => props?.dataParams?.[fieldName] || "";
  const [selectedAttendanceeType, setSelectedAttendanceType] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].attendance_type
      : ""
  );
  const [selectedAttendanceeTypeName, setSelectedAttendanceTypeName] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].attendance_typename
      : ""
  );
  const [selectedDate, setSelectedDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [selectedFloor, setSelectedFloor] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].floor
      : ""
  );
  const [selectedFloorName, setSelectedFloorName] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].floor_name
      : ""
  );
 
  const [selectOrgnizationType, setSelectOrgnizationType] = useState('');

  
  useEffect(() => {
    loadData();
   loadDataMatch();
  }, []);



  const loadData = () => {
    setLoader(true);
      const form = new FormData();
       form.append("staff_id", props.context.user.id);
    axios.post(ServiceUrl.MOB.GET_SERVICE_DETAILS, form).then((res) => {
      if (res["data"].status == "1") {
          setService(res["data"].data);

      } else {
        toast.error(res["data"].message || "Error");
      }
      setLoader(false);
  });
  };
  const topicList = (items) => {
    return items.map((item) => (
      <List.Item
        onClick={(e) => onTopicClick(item)}
        extra={
          <>
            {item.topic_periods_or_hours}
            {item.topic_periods_or_hours && `H`}
          </>
        }
        clickable
      >
        {item.topic_name}
      </List.Item>
    ));
  };
  const loadDataMatch = () => {
    setLoader(true);
      const form = new FormData();
      form.append("staff_id", props.context.user.id);
      form.append("date", selectedDate);
      //form.append("srv_org_id",selectOrgnizationType)
    axios.post(ServiceUrl.MOB.GET_SERVICE_MATCH_DETAILS, form).then((res) => {
      if (res["data"].status == "1") {
          setServiceMatch(res["data"].data);

      } else {
        toast.error(res["data"].message || "Error");
      }
      setLoader(false);
  });
  };

  const handleStartTimeChange = (e) => {
    setStartTime(e.target.value);
  };

  const handleEndTimeChange = (e) => {
    setEndTime(e.target.value);
  };

  const handleOrganizationChange = (e) => {
    setSelectOrgnizationType(e.target.value);
  };

  const onfinish = (item) => {
    const srv_org_name = service.find(org => org.srv_org_id === selectOrgnizationType)?.srv_org_name || "";


    const attendance = [
      {
       
     date: selectedDate,
    srv_org_id: selectOrgnizationType,
    srv_org_name: srv_org_name, 
    from_time: startTime,
     to_time:endTime,
      },
    ];
    if (props.onSuccess) props.onSuccess(attendance);
  };
  let cat;
  let floor;

  // const filteredService = service.filter(item =>
  //   serviceMatch.some(match => match.srv_org_id != item.srv_org_id)
  // );
  // const validSrvOrgIds = serviceMatch.map(item => item.srv_org_id);
  // const filteredService = validSrvOrgIds.length > 0
  //   ? service.filter(item => !validSrvOrgIds.includes(item.srv_org_id))
  //   : service; // Show all services if no valid ids

  return (
    <>
      <>
        <Card>
          <Card.Body>
            <Form
              name="from"
              id="attendance"
              onFinish={(e) => onfinish(e)}
              footer={
                <Button
                  type="submit"
                  variant="danger"
                  size="lg"
                  className="w-100"
                >
                  Search
                </Button>
              }
            >
              <Form.Item name="course_type" label={<span>Attendance Date <span className="text-danger">*</span></span>}>

                <input
                  className="form-control form-control-sm fw-bold"
                  type="date"
                  size="sm"
                  required
                  max={momentDate(new Date(), "YYYY-MM-DD")}

                  onChange={(e) => setSelectedDate(e.target.value)}
                  defaultValue={selectedDate}
                />
              </Form.Item>

             <Form.Item  name="srv_org_id"   label={<span>Service Organization Name <span className="text-danger">*</span></span>}>

      <select
        className="form-select form-select-sm fw-bold"
        value={selectOrgnizationType}
        onChange={handleOrganizationChange}
      >
        <option value="">-Select-</option>
        {service.map((item) => (
          <option key={item.srv_org_id} value={item.srv_org_id}>
            {item.srv_org_name}
          </option>
        ))}
      </select>
    </Form.Item>


       <Form.Item  label={<span>Attendance Time Range <span className="text-danger">*</span></span>}>

      <div style={{ display: 'flex', gap: '10px' }}>
        <input
          className="form-control form-control-sm fw-bold"
          type="time"
          name="from_time"
          size="sm"
          required
          onChange={handleStartTimeChange}
          value={startTime}
          placeholder="Start Time"
        />
        <input
          className="form-control form-control-sm fw-bold"
          type="time"
          name="to_time"
          size="sm"
          required
          onChange={handleEndTimeChange}
          value={endTime}
          placeholder="End Time"
        />
      </div>
    </Form.Item>

            </Form>
          </Card.Body>
        </Card>
      </>
    </>
  );
};
export default AttendanceTypeSelectView;
